"use strict";

exports.__esModule = true;
var _Logbook = require("./Logbook");
Object.keys(_Logbook).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Logbook[key]) return;
  exports[key] = _Logbook[key];
});
var _LogbookPanel = require("./LogbookPanel");
Object.keys(_LogbookPanel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LogbookPanel[key]) return;
  exports[key] = _LogbookPanel[key];
});
var _NewLogbookTicket = require("./NewLogbookTicket");
Object.keys(_NewLogbookTicket).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewLogbookTicket[key]) return;
  exports[key] = _NewLogbookTicket[key];
});
var _LogbookContext = require("./LogbookContext");
Object.keys(_LogbookContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LogbookContext[key]) return;
  exports[key] = _LogbookContext[key];
});
var _LogbookTicketDetails = require("./LogbookTicketDetails");
Object.keys(_LogbookTicketDetails).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LogbookTicketDetails[key]) return;
  exports[key] = _LogbookTicketDetails[key];
});
var _NewLogbookComment = require("./NewLogbookComment");
Object.keys(_NewLogbookComment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewLogbookComment[key]) return;
  exports[key] = _NewLogbookComment[key];
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  exports[key] = _types[key];
});